import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const showUp = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Webinar registered", { props: { triggerType: "Form Submitted", event: "Webinar registration" } }],
  ["e1", "auto-email", "You're in + calendar link", { props: { subject: "You're registered — add it to your calendar" } }],
  ["w1", "auto-wait", "Wait 1 day", { props: { duration: "1", unit: "days" } }],
  ["e2", "auto-email", "What you'll learn", { props: { subject: "3 things we'll cover live" } }],
  ["s1", "auto-sms", "Starting in 1 hour", { props: { message: "We're live in 1 hour — grab your seat: {{webinar.link}}" } }],
]);

const replay = column("f2", 100, 70, 92, [
  ["t2", "auto-trigger", "Webinar ended", { props: { triggerType: "Scheduled", event: "Webinar end + 30 min" } }],
  ["c1", "auto-condition", "Attended?", { props: { condition: "Has tag 'attended'" } }],
  ["e3", "auto-email", "Replay (48h)", { props: { subject: "Missed it? Replay comes down Friday" } }],
  ["w2", "auto-wait", "Wait 1 day", { props: { duration: "1", unit: "days" } }],
  ["e4", "auto-email", "Offer closes tonight", { props: { subject: "Doors close at midnight" } }],
]);

const def: TemplateDef = {
  slug: "webinar-funnel",
  name: "Webinar Funnel",
  category: "Events",
  tagline:
    "Registration, show-up sequence, replay window, and a closing pitch — on one map.",
  description:
    "A free webinar funnel template: registration page, a show-up email/SMS sequence, the live room, and a replay-plus-close automation with an attended branch. Clone it into FrazzleCRM and run the whole event from one canvas.",
  whatsInside: [
    "Registration page feeding a confirmation + reminder sequence",
    "1-hour-before SMS for show-up rates",
    "Replay flow with an Attended? branch and a deadline close email",
    "Checkout wired straight off the replay window",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-email", "Email blast", 40, 60, { props: { list: "Main list" } }),
      node("src2", "traffic-direct", "Partners", 40, 220, { props: { source: "JV / affiliates" } }),
      node("reg", "page-webinar-reg", "Registration", 360, 140),
      flow("f1", "Show-up Sequence", 680, 40, 420, 580),
      ...showUp.nodes,
      node("live", "page-webinar", "Live webinar", 1180, 140, { props: { topic: "The big promise" } }),
      node("rep", "page-webinar-replay", "Replay page", 1500, 140, { props: { expires: "48 hours" } }),
      flow("f2", "Replay & Close", 1820, 40, 420, 580),
      ...replay.nodes,
      node("co", "page-checkout", "Checkout", 2340, 260, { props: { price: "$497" } }),
    ],
    [
      edge("src1", "reg"),
      edge("src2", "reg"),
      edge("reg", "f1"),
      ...showUp.edges,
      edge("f1", "live"),
      edge("live", "rep"),
      edge("rep", "f2"),
      ...replay.edges,
      edge("f2", "co"),
    ]
  ),
};

export default def;
